<div  class="container-fluid container-background">


  <!-- header row top bar contains title, menu, options -->
  <div class="row">

        <!-- affixed header box sets padding for right menu -->
        <div class="col-xs-12 col-sm-6 col-md-5 col-lg-5 col-xl-4 bgwhite">

        <div class="outer">
            <div class="middle">

                <div *ngIf="error" class="error-general-overlay error-general-overlay-login">
                    <div class="row">
                        <div class="col-xs-12"><i class="fas fa-exclamation-triangle"></i> {{error.code}} {{error.msg}}</div>
                    </div>
                </div>

                <div *ngIf="!error">

                    <div class="login-form-container">
                        <div class="login-header-title">
                            <i  class="zmdi zmdi-lock zdmi-fw"></i> Select an Account
                        </div>
                        You will still be given an opportunity to inspect what the app is requesting access to.

                        <div *ngIf="user" style="padding-top: 10%;">
                            You are currently signed in as: <b>{{user.email}}</b>
                        </div>
                    </div>
                    <!-- login form conteiner -->
                    <button
                        *ngIf="!user"
                        id="btn-auth-login"
                        (click)="signInNew()"
                        class="btn-block btn btn-primary btn-lg btn-oauth showhand">Sign in</button>

                    <button
                        *ngIf="user"
                        id="btn-auth-login"
                        (click)="signInCurrent()"
                        class="btn-block btn btn-primary btn-lg btn-oauth showhand">Continue</button>
                    <button
                        *ngIf="user"
                        id="btn-auth-login"
                        (click)="signInDifferent()"
                        class="btn-block btn btn-primary btn-lg btn-oauth showhand"><span class="hidden-xs hidden-sm">Sign in as a  </span>Different User</button>
                </div>
            </div> <!-- middle -->
        </div> <!-- outer -->

    </div>
    <div class="hidden-xs col-sm-6 col-md-7 col-lg-7 col-xl-8">
          <!-- future -->

    </div>


  </div> <!-- row -->

  </div>
